import React from 'react';
import { Typography, Row, Col, Divider } from 'antd';
import { PhoneOutlined, MailOutlined, ToolOutlined } from '@ant-design/icons';
import { shopConfig } from '../../config/shop.config';

const { Text, Title } = Typography;

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ backgroundColor: '#111827', color: 'white', padding: '60px 20px 30px' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <Row gutter={[32, 32]}>
          {/* Company Info */}
          <Col xs={24} md={8}>
            <div style={{ marginBottom: '16px' }}>
              <ToolOutlined style={{ fontSize: '32px', color: '#3b82f6', marginBottom: '16px' }} />
              <Title level={4} style={{ color: 'white', marginBottom: '12px' }}>
                {shopConfig.name}
              </Title>
              <Text style={{ color: '#9ca3af', display: 'block', marginBottom: '8px' }}>
                {shopConfig.tagline}
              </Text>
            </div>
          </Col>

          {/* Quick Links */}
          <Col xs={24} md={8}>
            <Title level={5} style={{ color: 'white', marginBottom: '16px' }}>
              Our Services
            </Title>
            <div style={{ color: '#9ca3af' }}>
              <Text style={{ color: '#9ca3af', display: 'block', marginBottom: '8px' }}>
                • Engine & Transmission Repair
              </Text>
              <Text style={{ color: '#9ca3af', display: 'block', marginBottom: '8px' }}>
                • Advanced Diagnostics
              </Text>
              <Text style={{ color: '#9ca3af', display: 'block', marginBottom: '8px' }}>
                • Complete Maintenance
              </Text>
              <Text style={{ color: '#9ca3af', display: 'block', marginBottom: '8px' }}>
                • Pre-Purchase Inspections
              </Text>
            </div>
          </Col>

          {/* Contact Info */}
          <Col xs={24} md={8}>
            <Title level={5} style={{ color: 'white', marginBottom: '16px' }}>
              Contact Us
            </Title>
            <div>
              <div style={{ marginBottom: '12px' }}>
                <PhoneOutlined style={{ color: '#3b82f6', marginRight: '8px' }} />
                <Text style={{ color: '#9ca3af' }}>{shopConfig.cta.phoneDisplay}</Text>
              </div>
              <div style={{ marginBottom: '12px' }}>
                <MailOutlined style={{ color: '#3b82f6', marginRight: '8px' }} />
                <Text style={{ color: '#9ca3af' }}>{shopConfig.email}</Text>
              </div>
              <div style={{ marginTop: '16px', color: '#9ca3af' }}>
                <Text style={{ color: '#9ca3af', display: 'block' }}>
                  {shopConfig.address.street}
                </Text>
                <Text style={{ color: '#9ca3af', display: 'block' }}>
                  {shopConfig.address.city}, {shopConfig.address.state} {shopConfig.address.zip}
                </Text>
              </div>
            </div>
          </Col>
        </Row>

        <Divider style={{ borderColor: '#374151', margin: '40px 0 24px' }} />

        {/* Bottom Bar */}
        <Row justify="space-between" align="middle">
          <Col xs={24} md={12} style={{ textAlign: window.innerWidth < 768 ? 'center' : 'left', marginBottom: window.innerWidth < 768 ? '16px' : '0' }}>
            <Text style={{ color: '#6b7280', fontSize: '14px' }}>
              © {currentYear} {shopConfig.name}. All rights reserved.
            </Text>
          </Col>
          <Col xs={24} md={12} style={{ textAlign: window.innerWidth < 768 ? 'center' : 'right' }}>
            <Text style={{ color: '#6b7280', fontSize: '14px' }}>
              Professional Automotive Service & Repair
            </Text>
          </Col>
        </Row>
      </div>
    </footer>
  );
};

export default Footer;
